var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBallon = function SvgBallon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor",
    style: {
      color: "#b2c9de"
    }
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.834 4.167a4.5 4.5 0 0 0-.282 8.991c.44.027.782.391.782.832v.786l1.52-1.391a.833.833 0 0 1 .563-.218h1.75a4.5 4.5 0 0 0 0-9H7.834Zm-6.167 4.5A6.167 6.167 0 0 1 7.834 2.5h4.333a6.167 6.167 0 1 1 0 12.333h-1.426l-2.678 2.449a.833.833 0 0 1-1.396-.615v-1.944a6.168 6.168 0 0 1-5-6.056ZM5.834 7.5c0-.46.373-.833.833-.833h4.167a.833.833 0 0 1 0 1.666H6.667a.833.833 0 0 1-.833-.833Zm.833 1.667a.833.833 0 0 0 0 1.666h6.667a.833.833 0 0 0 0-1.666H6.667Z",
    clipRule: "evenodd"
  })));
};
export default SvgBallon;